export default __webpack_public_path__ + "static/cars-2a3e04c83d66c5d81e0cfd587b348cfd.png";